import React from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroSection = ({ onInquiryClick }) => {
  return (
    <section className="relative h-[600px] lg:h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <Image
          src="https://images.unsplash.com/photo-1660511057210-f7fba78d2741"
          alt="Elegant catering setup with Italian appetizers and pastries beautifully arranged on white tablecloths with fresh flowers and wine glasses at corporate event"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/80 to-transparent" />
      </div>

      <div className="relative container-custom h-full flex items-center">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/20 backdrop-blur-sm mb-6">
            <div className="w-2 h-2 rounded-full bg-accent animate-pulse" />
            <span className="text-sm font-medium text-accent">
              Serving 50+ Corporate Events Monthly
            </span>
          </div>

          <h1 className="font-serif text-5xl lg:text-6xl font-bold text-foreground mb-6 leading-tight">
            Elevate Your Events with
            <span className="text-primary block mt-2">Authentic Italian Catering</span>
          </h1>

          <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
            From intimate gatherings to grand celebrations, we bring the warmth of Italian hospitality and the excellence of artisan craftsmanship to every occasion. Trusted by Toronto's leading businesses and families since 1985.
          </p>

          <div className="flex flex-wrap gap-4">
            <Button
              variant="default"
              size="lg"
              iconName="Calendar"
              iconPosition="left"
              onClick={onInquiryClick}>

              Request Catering Quote
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="Phone"
              iconPosition="left">

              Call (416) 555-0123
            </Button>
          </div>

          <div className="flex items-center gap-8 mt-8 pt-8 border-t border-border">
            <div>
              <div className="text-3xl font-bold text-primary">500+</div>
              <div className="text-sm text-muted-foreground">Events Catered</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary">4.8★</div>
              <div className="text-sm text-muted-foreground">Client Rating</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary">100%</div>
              <div className="text-sm text-muted-foreground">Fresh Daily</div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;